import { gql, useMutation } from '@apollo/client';

import type {
  UpdateDependentEmailMutation,
  UpdateDependentEmailMutationVariables,
} from './__generated__/useUpdateDependentEmail.gql';

const UPDATE_DEPENDENT_EMAIL = gql`
  mutation UpdateDependentEmail($input: UpdateDependentEmailInput!) {
    updateDependentEmail(input: $input) {
      id
      email
    }
  }
`;

/**
 * Change or clear a loved one's email address, wherever that address lives.
 *
 * `updateDependant` hands an `email` to the same server writer, but its patch can
 * carry other fields too, so a refusal there cannot say which field it was
 * about. This mutation takes the address alone, and the server picks the row
 * from linkage.
 *
 * @returns The standard `useMutation` tuple — `[mutate, MutationResult]`.
 */
export const useUpdateDependentEmail = () => {
  return useMutation<UpdateDependentEmailMutation, UpdateDependentEmailMutationVariables>(UPDATE_DEPENDENT_EMAIL);
};
